export const SET_COLLAPSE_TRUE = 'SET_COLLAPSE_TRUE';
export const SET_COLLAPSE_FALSE = 'SET_COLLAPSE_FALSE'; 